import { copyLinkToClipboard, copyLinkFeedback } from './copy-to-clipboard';

class Downloads
{
    constructor()
    {
        // elements
        this.page = document.querySelector('#account-downloads');
        this.template = document.querySelector('.download-list__item');

        // tabs
        this.tabArticleData = document.querySelector('.tab-article-data .download-list');
        this.tabBrochuresFlyer = document.querySelector('.tab-brochures-flyer .download-list');
        this.tabEpaper = document.querySelector('.tab-epaper .download-list');

        // api
        this.api = orion.api.downloads;

        // helper
        this.currentDate = new Date();
    }

    init()
    {
        if (this.page === null)
        {
            return;
        }

        this.fetchDownloads();
    }

    fetchDownloads()
    {
        this.api.read().done((data) =>
        {
            let downloadItems = data.ManagedDownloadList;

            this.processDownloads(downloadItems);
        });
    }

    processDownloads(downloadItems)
    {
        downloadItems.forEach((download) =>
        {
            let downloadItem = download.managedDownload;

            let valid = this.checkValidity(downloadItem.validFromDatetime, downloadItem.validUntilDatetime);

            if (valid)
            {
                let clone = this.createDownloadElement(downloadItem);

                this.attachDownload(downloadItem.downloadCategory, clone);
            }
        });
    }

    createDownloadElement(downloadItem)
    {
        let clone = this.template.cloneNode(true);
        let fileIcon = clone.querySelector('.download-list__file-icon');
        let newBadge = clone.querySelector('.download-list__badge');
        let customerFlag = clone.querySelector('.download-list__customer-icon');
        let title = clone.querySelector('.download-list__title--text');
        let date = clone.querySelector('.download-list__title--date');
        let description = clone.querySelector('.download-list__description--text');
        let fileExtension = clone.querySelector('.download-list__description--extension');
        let badgeOffset = clone.querySelector('.download-list__offset');
        let faqLink = clone.querySelector('.download-list__faq');
        let copyLink = clone.querySelector('.download-list__copy');
        let copyLinkButton = clone.querySelector('.download-list__copy--button');
        let downloadButton = clone.querySelector('.download-list__download--button');

        if (downloadItem.isNew == 'true')
        {
            newBadge.classList.remove('hidden');
        }
        else
        {
            badgeOffset.classList.remove('hidden');
        }

        if (downloadItem.customerFlag == '1')
        {
            customerFlag.classList.remove('hidden');
        }

        fileIcon.src = 'assets/images/icons/file_' + downloadItem.filename.split('.')[1] + '.svg';
        title.textContent = this.replaceUmlaute(downloadItem.title);
        description.textContent = this.replaceUmlaute(downloadItem.description);
        fileExtension.textContent = '(.' + downloadItem.filename.split('.')[1] + ')';

        if (downloadItem.creationDatetime != '')
        {
            let dateArray = downloadItem.creationDatetime.split(' ')[0].split('-');
            let formatDate = dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];

            date.textContent = '(' + formatDate + ')';
        }

        if (downloadItem.filename.split('.')[1] == 'xml' || downloadItem.filename.split('.')[1] == 'csv')
        {
            copyLink.classList.add('has-faq-link');
            faqLink.classList.remove('hidden');
        }

        copyLinkButton.setAttribute('data-target', 'download-' + downloadItem.managedDownloadId);

        copyLinkButton.addEventListener('click', function(event)
        {
            copyLinkToClipboard('#download-' + downloadItem.managedDownloadId);
            copyLinkFeedback(copyLinkButton);
            event.preventDefault();
        });

        downloadButton.id = 'download-' + downloadItem.managedDownloadId;
        downloadButton.href += downloadItem.filename;

        clone.classList.add('download-' + downloadItem.managedDownloadId);
        clone.classList.remove('hidden');

        return clone;
    }

    replaceUmlaute(text)
    {
        text = text.replace(/&Auml;/g, 'Ä')
            .replace(/&auml;/g, 'ä')
            .replace(/&Uuml;/g, 'Ü')
            .replace(/&uuml;/g, 'ü')
            .replace(/&Ouml;/g, 'Ö')
            .replace(/&ouml;/g, 'ö')
            .replace(/&szlig;/g, 'ß');

        return text;
    }

    checkValidity(validFromDatetime, validUntilDatetime)
    {
        let validFromDate = new Date(validFromDatetime);
        let validUntilDate = new Date(validUntilDatetime);

        return validFromDate < this.currentDate && this.currentDate < validUntilDate;
    }

    attachDownload(category, clone)
    {
        switch (category)
        {
        case 'ARTICLE_DATA':
            this.tabArticleData.prepend(clone);
            break;
        case 'CATALOG':
            this.tabBrochuresFlyer.prepend(clone);
            break;
        case 'EPAPER':
            this.tabEpaper.prepend(clone);
            break;
        }
    }
}

document.addEventListener('DOMContentLoaded', () =>
{
    let downloads = new Downloads();

    downloads.init();
});
